const addUser = async ({ commit, rootState, state }) => {
  if (rootState.user.id && !state.users[rootState.user.id]) {
    commit('ADD_USER', rootState.user.id)
  }
}
const setPropToUser = async ({ commit, rootState, dispatch }, data) => {
  dispatch('addUser')
  commit('SET_USER_PROP', { key: data.key, value: data.value, userId: rootState.user.id })
}
export default {
  addUser,
  setPropToUser
}



// WEBPACK FOOTER //
// ./src/store/modules/user/locally/actions.js